// Email-safe callout HTML blocks — table-based, inline-styled, 4px left border, rounded.

export const CALLOUT_KINDS = [
    { key: "key", label: "Key information" },
    { key: "note", label: "Note" },
    { key: "good", label: "Good news" },
    { key: "attention", label: "Attention" },
    { key: "action", label: "Action required" },
];

const STYLES = {
    key:       { border: "#8EC740", bg: "#F3F5F7", title: "#1A3E6D", titleText: "Key information" },
    note:      { border: "#1A3E6D", bg: "#F3F5F7", title: "#1A3E6D", titleText: "Note" },
    good:      { border: "#8EC740", bg: "#8EC740", title: "#1A3E6D", titleText: "Good news" },
    attention: { border: "#D4C93A", bg: "#FBF8E2", title: "#1A3E6D", titleText: "Attention" },
    action:    { border: "#C0392B", bg: "#FBE9E7", title: "#C0392B", titleText: "Action required" },
};

export function calloutHtml(kind, title, body) {
    const s = STYLES[kind] || STYLES.key;
    const t = title || s.titleText;
    const b = body || "Add your details here.";
    return (
        `<table role="presentation" cellspacing="0" cellpadding="0" border="0" ` +
        `style="width:100%;border-collapse:separate;border-left:4px solid ${s.border};` +
        `background:${s.bg};border-radius:10px;margin:18px 0;">` +
        `<tr><td style="padding:14px 18px;font-family:Poppins,Arial,sans-serif;color:#1A1A1A;">` +
        `<div style="font-weight:600;color:${s.title};margin-bottom:4px;font-size:14px;">${t}</div>` +
        `<div style="font-size:14px;line-height:1.55;">${b}</div>` +
        `</td></tr></table>`
    );
}
